import $ from "jquery"

/**
 * Scripts for stat section animate numbers
 */
 if($('.js-stats').length){
    $(window).on('scroll', animateNumberScroll);
    var viewed = false;

    function isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();

        var returnVal = false;

        if(elem.length){
            returnVal = ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }

        return returnVal;
    }

    function animateNumberScroll() {
        if (isScrolledIntoView($(".js-stats")) && !viewed) {
            viewed = true;

            $('.value').each(function () {
                var dataVal = $(this).data('value');
                var durationVal = 2500;

                if(dataVal < 100){
                    durationVal = 1000;
                }

                $(this).prop('Counter', 0).animate({
                    Counter: dataVal
                }, {
                    duration: durationVal,
                    easing: 'swing',
                    step: function (now) {
                        if(Number.isSafeInteger(dataVal)){
                            $(this).text(Math.ceil(now));
                        }else{
                            $(this).text(parseFloat(now).toFixed(1));
                        }
                    }
                });
            });
        }
    }
}